export class DashboardCounterModel {
   ID: number;
   TenderOnProgress: number;
   HavingResult: number;
   UpcommingTender: number;
   UpcomingResult: number;
}
